module.exports = "/static/media/add_icon.99c34544.svg";